import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73d56bb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-info row items-center q-gutter-sm" }
const _hoisted_2 = { class: "btn-wrap" }

import { PropType, ref, watch } from 'vue'
import { AgreementContactPerson } from '@/modules/agreements/types'


export default /*#__PURE__*/_defineComponent({
  props: {
    contact: {
        type: Object as PropType<AgreementContactPerson>,
        required: true
    },
    contactTypes: {
        type: Array as PropType<string[]>,
        required: true
    }
},
  emits: ['update', 'delete'],
  setup(__props, { expose, emit }) {

const props = __props





const localContact = ref({ ...props.contact })

const emailError = ref('')
const nameError = ref('')
const typesError = ref('')
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

watch(
    () => props.contact,
    (newContact) => {
        localContact.value = { ...newContact }
    }
)

function validateEmail () {
    if (!emailRegex.test(localContact.value.email)) {
        emailError.value = 'Invalid email format'
    } else {
        emailError.value = ''
    }
}

function validateName () {
    if (!localContact.value.name) {
        nameError.value = 'Name is required'
    } else {
        nameError.value = ''
    }
}

function validateTypes () {
    if (!localContact.value.types.length) {
        typesError.value = 'At least one type is required'
    } else {
        typesError.value = ''
    }
}

function validate (): boolean {
    validateEmail()
    validateName()
    validateTypes()
    return noError()
}

function markEmailAsDuplicated (isDuplicated: boolean) {
    if (isDuplicated) {
        emailError.value = 'Email already exists'
    } else {
        emailError.value = ''
    }
}

function email () {
    return localContact.value.email
}

function onEdit () {
    if (validate()) {
        emit('update', localContact.value)
    }
}

function noError () {
    return !emailError.value && !nameError.value && !typesError.value
}

function onDelete () {
    emit('delete', localContact.value)
}

expose({
    email,
    validate,
    markEmailAsDuplicated
})

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_input, {
      modelValue: localContact.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localContact.value.name) = $event)),
      label: "Name",
      outlined: "",
      dense: "",
      onBlur: onEdit,
      error: !!nameError.value,
      "error-message": nameError.value
    }, null, 8, ["modelValue", "error", "error-message"]),
    _createVNode(_component_q_input, {
      modelValue: localContact.value.email,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localContact.value.email) = $event)),
      label: "Email",
      outlined: "",
      dense: "",
      type: "email",
      onBlur: onEdit,
      error: !!emailError.value,
      "error-message": emailError.value
    }, null, 8, ["modelValue", "error", "error-message"]),
    _createVNode(_component_q_select, {
      modelValue: localContact.value.types,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localContact.value.types) = $event)),
      options: __props.contactTypes,
      label: "Types",
      outlined: "",
      dense: "",
      multiple: "",
      "emit-value": "",
      "map-options": "",
      onBlur: onEdit,
      error: !!typesError.value,
      "error-message": typesError.value
    }, null, 8, ["modelValue", "options", "error", "error-message"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_btn, {
        color: "negative",
        onClick: onDelete,
        label: "Remove",
        "no-caps": "",
        unelevated: ""
      })
    ])
  ]))
}
}

})